import Head from 'next/head';
import {REGION, WEB_HOST} from '../constant';

export default function StructuredData() {
  if (REGION !== 'kor') {
    return null;
  }

  return (
    <Head>
      <script
        key="structured-data"
        type="application/ld+json"
        dangerouslySetInnerHTML={{__html: JSON.stringify(STRUCTURED_DATA)}}
      />
    </Head>
  );
}

const STRUCTURED_DATA = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: '카카오웹툰',
  url: WEB_HOST,
  sameAs: [
    'https://www.instagram.com/kakaowebtoon/',
    'https://www.facebook.com/kakaowebtoon',
    'https://www.youtube.com/@kakaowebtoon.official',
    'https://twitter.com/kakaowebtoon_kr',
    'https://play.google.com/store/apps/details?id=net.daum.android.webtoon',
    'https://apps.apple.com/kr/app/id736602666',
  ],
};
